/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { UserRemoveMemberPathParams, UserRemoveMemberResponse } from '../types/UserRemoveMember'

/**
 * DELETE /users/:user
 * @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::removeMember
 */
export async function userRemoveMember(
	user: UserRemoveMemberPathParams['user'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<UserRemoveMemberResponse>> {
	return axiosInstance.delete(`/users/${user}`, config)
}
